export default class scrollIcon {
    constructor(manager){

        //manager
        this.manager = manager;

        //dom
        this.$target = document.getElementById('c-scroll__inner');
        this.$targetIcon = document.querySelector('#c-scroll-circle .icon');

        this.status = {
            h:0,
        }

        this.status.h = this.$target.clientHeight - 5;

        this.tl = new TimelineMax({repeat:-1,repeatDelay:0.6});

    }
    init(){

        this.start();

    }

    start(){

        this.tl.to(this.$targetIcon, 1.4 , {
            y: this.status.h,
            onStart:() => {
                TweenMax.to(this.$targetIcon, .4 , {
                    delay: 1.0,
                    opacity: 0,
                });
            }
        }).set(this.$targetIcon , {
            y: -2,
            opacity: 0,
        }).to(this.$targetIcon, .8 , {
            y: 0,
            delay:0.3,
            opacity: 1,
        });

    }

    show(){

        TweenMax.to(this.$target, 1.2 , {
            opacity: 1,
            y:0,
            display: 'block'
        });
        this.tl.play();

    }

    hide(){

        TweenMax.to(this.$target, 1.2 , {
            opacity: 0,
            y:0,
            display: 'none'
        })
        this.tl.pause();

    }

    play(){
        this.tl.play();
    }

}